<!--
 * @Author: AnNa
 * @Date: 2021-08-09 11:29:15
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-19 09:55:42
 * @Description:
-->
<template>
  <a-modal
    :width="800"
    title="新增抽奖"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" @submit="handleSubmit">
      <a-form-item label="抽奖名称">
        <a-input
          placeholder="抽奖名称"
          v-decorator="['luckydraw_name', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
      <a-form-item label="单个红包金额">
        <a-input-number
          placeholder="红包金额"
          :format="value => `￥${value}`"
          v-decorator="['per_packet_amount', {initialValue: 0 , rules: [{validator: validatePerPacket}]}]"
        />
      </a-form-item>
      <a-form-item label="红包总金额">
        <a-input-number
          placeholder="总金额"
          v-decorator="['packet_amount', {initialValue: 0 , rules: [{validator: validatePerPacket}]}]"
        />
      </a-form-item>
      <a-form-item label="全部必中">
        <a-switch
          v-decorator="['certain_mark', {initialValue: false, valuePropName: 'checked' }]"
        />
      </a-form-item>

      <a-form-item label="抽奖有效期">
        <a-date-picker v-decorator="['start_time',{ rules: [{ required: true, message: '必填项' }] }]" />
        <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }"> - </span>
        <a-date-picker v-decorator="['end_time',{ rules: [{ required: true, message: '必填项' }] }]" />
      </a-form-item>
      <a-form-item label="抽奖规则说明">
        <a-textarea
          :maxLength="500"
          v-decorator="['luckydraw_desc', { rules: [{ required: true, message: '必填项' }] }]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { LuckyAPI } from '@/api/lucky'
import moment from 'moment'
import { to } from '@/utils/await'
import { message } from 'ant-design-vue'

export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      confirmLoading: false,
      currentRobotId: null
    }
  },

  methods: {
    validatePerPacket(rule, value, callback) {
      const errors = []
      if (rule.field === 'per_packet_amount') {
        if (value < 0) {
          errors.push(new Error('金额不能小于0'))
        }
        const packetAmount = this.form.getFieldValue('packet_amount')
        if (packetAmount) {
          if (value >= packetAmount) {
            errors.push(new Error('单个金额不能大于等于总金额！'))
          }
        }
      } else if (rule.field === 'packet_amount') {
        if (value < 0) {
          errors.push(new Error('金额不能小于0'))
        }
        const packetAmount = this.form.getFieldValue('per_packet_amount')
        if (packetAmount) {
          if (value <= packetAmount) {
            errors.push(new Error('总金额不能小于等于单个金额！'))
          }
        }
      }
      callback(errors)
    },
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    copyText(text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    copyEmoji(emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    handleSelectSub() {
      this.$refs.robot.show()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const [msg] = await to(LuckyAPI.addLucky({
            ...values,
            start_time: moment(values.start_time).format('YYYY-MM-DD') + ' 00:00:00',
            end_time: moment(values.end_time).format('YYYY-MM-DD') + ' 23:59:59',
            per_packet_amount: values.per_packet_amount ? Number(values.per_packet_amount) * 100 : values.per_packet_amount,
            packet_amount: values.packet_amount ? Number(values.packet_amount) * 100 : values.packet_amount,
            sub_id: this.currentRobotId
          }))
          if (!msg) {
            this.visible = false
            this.form.resetFields()
            this.$emit('ok')
            return
          }
          message.error(msg)
        }
      })
    },
    replace(str) {
      if (str.indexOf('\\ue') !== -1) {
        // eslint-disable-next-line no-eval
        var a = str.substr(str.indexOf('\\ue'), 6)
        str = str.replace(a, eval("'" + a + "'"))
        return this.replace(str)
      } else {
        return str
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleOk(record) {
      this.form.setFieldsValue({
        robot_id: record.id,
        servant_id: record.servant_id
      })
    }
  }
}
</script>
